// extracted by css-extract-rspack-plugin
export default {"ColorButton":"pF2hZ","secondary":"VSvim"};